import { render } from "./Row12.vue?vue&type=template&id=8b948dc0"
import script from "./Row12.vue?vue&type=script&lang=js"
export * from "./Row12.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__